/**
 * Como se le dice a la persona que es lo que tiene cargado en un documento.
 *
 * La tarjeta verde solo decia "Cargado", asi que no habia forma de saber que
 * archivo quedo ahi sin borrarlo y volver a subirlo.
 */

/** El nombre del archivo, sin la ruta con la que viaja. */
export const nombreDeArchivo = (ruta: any): string => {
  const texto = String(ruta ?? "").trim();
  if (!texto) return "";

  const soloNombre = texto.split(/[\\/]/).pop() ?? texto;
  // Algunos llegan con la firma de descarga pegada detras.
  return soloNombre.split("?")[0] || texto;
};

/**
 * Lo que se muestra bajo el titulo de un documento ya puesto: el archivo que
 * se subio, o la constancia de que se lleno en linea cuando no hay archivo.
 */
export const loQueEstaCargado = (data: any): string => {
  const archivo = nombreDeArchivo(data?.url_participante);
  if (archivo) return archivo;

  if (data?.escrito || data?.url_video) return "Diligenciado en línea";
  if (data?.fecha_firma) return "Diligenciado y firmado en línea";

  return "Documento cargado";
};
